<template>
  <div  class="panel">
    <div class="title">量表结论展示<a-button class="title-btn" type="primary" @click="handleEdit">设置</a-button></div>
    <a-row>
      <a-col :span="2" style="text-align: right">展示量表：</a-col>
      <a-col :span="20">
        <template v-for="(form,index) in formList">
          <div v-if="form.patientView ==='1'" :key="index" class="row">
            {{index+1}}、{{form.name}}
          </div>
        </template>
      </a-col>
    </a-row>
    <show-scales-model ref="showScalesModel" @ok="loadData"></show-scales-model>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  import ShowScalesModel from './modal/ShowScalesModel'
  export default {
    name: 'ScaleFormSet',
    components: { ShowScalesModel },
    props:{
      projectId:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        formList:[],
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.loading = true
        getAction('/project/projectForm/listAll',{projectId:this.projectId,type:'2'}).then(res=>{
          if(res.success){
            this.formList = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleEdit(){
        this.$refs['showScalesModel'].edit(this.formList)
      },
    }
  }
</script>

<style scoped lang="less">
  .row{
    line-height: 25px;
  }
</style>